// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"350":"private-demo","535":"login","631":"contact","702":"users-list","898":"users-detail","942":"not-found"}[chunkId] + "." + {"350":"eb5201b9","535":"8cb104cc","631":"24f8681d","702":"317b84ca","898":"e28e61c8","942":"3aeb6e1b"}[chunkId] + ".js";
};